import React from 'react'
import AuthTemplate from 'components/templates/AuthTemplate'
import { LinearProgress } from '@mui/material'
import useEffectOnce from 'hooks/useEffectOnce'
import axios from 'providers/axios'
import { useNavigate, useSearchParams } from 'react-router-dom'
import useShowError from 'hooks/useShowError'
import { URL_APP } from 'helpers/config'
import useSnackbarStore from 'hooks/useSnackbarStore'

const VerifyEmail: React.FC = () => {
  const { openSnackbar } = useSnackbarStore()
  const showError = useShowError()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const token = searchParams.get('token')
  const email = searchParams.get('email')
  const redirectUrl = searchParams.get('redirectUrl') || URL_APP

  // Verify email and redirect
  useEffectOnce(() => {
    const verifyEmail = async () => {
      try {
        if (!token || !email) throw new Error('Missing token or email')
        await axios.post('/verify-email', { token, email, redirectUrl })
        openSnackbar('Email verified!', 'success', false)
        await redirect(redirectUrl)
      } catch (error) {
        showError(error)
        navigate('/login')
      }
    }

    verifyEmail()
  })

  const redirect = async (redirectUrl: string) => {
    const { data } = await axios.post('/login/status', { redirectUrl })
    if (data.isLoggedIn) {
      window.location.href = data.redirectUrl
    } else {
      const searchParams = new URLSearchParams({ redirectUrl })
      navigate(`/login?${searchParams.toString()}`)
    }
  }

  return (
    <AuthTemplate>
      <h1 className="fs-18">Verifying Email</h1>

      <LinearProgress sx={{ my: '40px', maxWidth: '400px', mx: 'auto' }} />
    </AuthTemplate>
  )
}

export default VerifyEmail
